import React, { forwardRef } from 'react';

import ClientConsumer from './Consumer';

// example usage :
// withClientContext('client')(Component);

export default (name) => (WrappedComponent) => {
  const WithClientContext = forwardRef((props, ref) => (
    <ClientConsumer name={name}>
      <WrappedComponent {...props} ref={ref} />
    </ClientConsumer>
  ));
  const wrappedName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  WithClientContext.displayName = `withClientContext(${wrappedName})`;
  return WithClientContext;
};
